/**
 * Should debugging information be displayed
 */
module.exports = () => {
  if (process.env.ENV !== 'production') {
    return true;
  } else {
    try {
      return localStorage.getItem('growDebug') !== null;
    } catch (e) {
      return false;
    }
  }
};


// WEBPACK FOOTER //
// ./~/@atlassiansox/experiment-common-core/lib/is-debugging-enabled.js